import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { useCommon } from "../context/CommonContext";
import { useLanguage } from "../context/LanguageProvider";

/**
 * IMG1 Component
 * -------------------
 * This React component implements a reaction-based game where:
 * - Certain "valid" numbers (selected by the user earlier) require a reaction (press space bar)
 * - "Invalid" numbers require no reaction
 * - The user must press the space bar within the configured reaction time for valid numbers
 * - After 3 consecutive correct reactions, the player moves to the next game stage
 * - Inactivity triggers an overlay message
 */

const IMG1 = () => {

    console.log("------------------IMG1 rendered----------------------");

    /* ---------------------- Context and Navigation ---------------------- */
    const location = useLocation(); // Router hook to access passed state
    const navigate = useNavigate(); // Router hook to navigate programmatically

    const { kioskTimeoutText } = useCommon(); // Global context: inactivity message text
    const { translation } = useLanguage();   // Global context: translation function

    // Retrieve numbers passed from previous screen (or default to empty arrays)
    const selectedNumbers = location.state?.selectedNumbers || [];
    const unSelectedNumbers = location.state?.unSelectedNumbers || [];

    /* ---------------------- Initial Validation on Mount ---------------------- */
    useEffect(() => {
        if (selectedNumbers.length === 0) {
            // If no valid numbers are provided, redirect to previous screen
            navigate("/IMGI1");
        }
        console.log("Selected numbers in IMG1:", selectedNumbers);
        console.log("Unselected numbers in IMG1:", unSelectedNumbers);
    }, [selectedNumbers, unSelectedNumbers]);

    /* ---------------------- Game Configuration ---------------------- */
    const config = {
        words: selectedNumbers,          // Valid stimuli
        invalidWords: unSelectedNumbers, // Invalid stimuli (should NOT react)
        minReactionTime: 1,              // Ignore reactions faster than this (too early)
        maxReactionTime: 1000,           // Allowed reaction window (ms)
                // preparationTime: 3000,
        // delayBetweenWords: 200,
        // delayedPlusMinus: 25,
        totalWords: 1000,
        delayBetweenWordsMin: 1000,      // Randomized inter-stimulus delay min
        delayBetweenWordsMax: 1500,      // Delay max
        startGameTime: 1000,             // Delay before first stimulus appears
        inactivityTime: 240000           // Time before inactivity overlay (4 min)
    };

    /* ---------------------- State Variables ---------------------- */
    const [isRunning, setIsRunning] = useState(false);       // Is the game currently active
    const [displayText, setDisplayText] = useState('');      // Current number shown
    const [message, setMessage] = useState('');              // Main feedback message
    const [results, setResults] = useState([]);              // Reaction results (time & number)
    const [wordsDisplayed, setWordsDisplayed] = useState(0); // Count of words shown so far
        // const [showNextButton, setShowNextButton] = useState(false);
    // const [showResults, setShowResults] = useState(false);
    const [isWordDisplaying, setIsWordDisplaying] = useState(false); // Is a stimulus currently visible
    const [isTransitioning, setIsTransitioning] = useState(false);   // Inter-word delay flag
    const [isInactive, setIsInactive] = useState(false);     // Show inactivity overlay
    const [message1, setMessage1] = useState('');            // Extra feedback line 1
    const [message2, setMessage2] = useState('');            // Extra feedback line 2
    const [isKeyTrackingDisabled, setIsKeyTrackingDisabled] = useState(false); // Lock user input

    /* ---------------------- Mutable References (persist across renders) ---------------------- */
    const consecutiveGoodReactionsRef = useRef(0); // Number of consecutive correct reactions
    const shuffledWordsRef = useRef([]);           // Shuffled array of all words
    const currentWordIndexRef = useRef(0);         // Current word's index in shuffled array
    const startTimeRef = useRef(null);             // Time when current word appeared
    const wordTimeoutRef = useRef(null);           // Timeout for reaction window
    const currentWordRef = useRef(null);           // Currently displayed word
    const delaywordRef = useRef(null);             // Timeout for delay between words
    const inactivityTimerRef = useRef(null);       // Timeout for inactivity detection

    /* Combine valid and invalid words into one pool for shuffling */
    const allWords = config.words.concat(config.invalidWords);

    /* ---------------------- Helper: Shuffle Words ---------------------- */
    const shuffleArray = (array) => {
        const shuffled = [...array];
        for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
        }
        return shuffled;
    };

    /* ---------------------- Start Game Automatically After Delay ---------------------- */
    useEffect(() => {
        const timer = setTimeout(() => {
            start();
        }, config.startGameTime);
        return () => clearTimeout(timer);
    }, []);

    /* ---------------------- Feedback Display ---------------------- */
    const showMessage = (text, isError = false) => {
                console.log(`showMessage called with text: "${text}", isError: ${isError}`);
        setMessage(text);
        setMessage1('');
        setMessage2('');
        if (isError) {
            // Show additional hints if this feedback is error-related
            setMessage1(translation("IMG1_mistakeMessage"));
            setMessage2(translation("IMG1_focusReminder"));
        }
    };

    /* ---------------------- Core Stimulus Presentation Logic ---------------------- */
    const displayWord = () => {
                console.log(`displayWord called. Words displayed: ${wordsDisplayed} , shuffled aaray - ${shuffledWordsRef.current}`);
        if (wordsDisplayed < shuffledWordsRef.current.length) {
                        // const currentWord = allWords[Math.floor(Math.random() * allWords.length)];
            const currentWord = shuffledWordsRef.current[currentWordIndexRef.current];
            currentWordRef.current = currentWord;
            setDisplayText(currentWord);
            setIsWordDisplaying(true);
            setIsTransitioning(false);
            startTimeRef.current = performance.now();
                        console.log(`Displaying Number: "${currentWord}"`);

            // If no reaction is detected in time
            wordTimeoutRef.current = setTimeout(() => {
                const isInvalidWord = config.invalidWords.includes(currentWordRef.current);
                if (!isInvalidWord) {
                                    console.log("too slow message from displayWord");
                    // Missed a valid number
                    const errorResult = {
                    Number: currentWordRef.current,
                    reactionTime: 'Error: Missed '
                };
                setResults(prev => [...prev, errorResult]);
                let missedmessage = translation("IMG1_missedInstruction") + config.words;
                showMessage(missedmessage, true);
                end(true);
                } else{
                    // Validly ignored an invalid number
                    setWordsDisplayed(prev => prev + 1);
                    currentWordIndexRef.current += 1;
                    setIsTransitioning(true);
                    setDisplayText('');
                    // const randomDelay = config.delayBetweenWords + (Math.random() < 0.5 ? -config.delayedPlusMinus : config.delayedPlusMinus);
                    // Random pause before next number
    const randomDelay2 = (Math.random()*(config.delayBetweenWordsMax-config.delayBetweenWordsMin)+config.delayBetweenWordsMin);
                    console.log(`random delay ${randomDelay2}`);
                    //(Math.random()*(5000-300)+300)
                    setTimeout(() => {
                        displayWord();
                    }, randomDelay2);
                }
            }, config.maxReactionTime);

        } else {
            // Game finished
             console.log('All words displayed. Ending the game.');
            end(false);
        }
    };

    /* ---------------------- Start Game ---------------------- */
    const start = () => {
        shuffledWordsRef.current = shuffleArray(allWords);
        currentWordIndexRef.current = 0;
        console.log('Game started.');
        setIsRunning(true);
        // setResults([]);
        setWordsDisplayed(1);
        setDisplayText('');
        // setShowNextButton(false);
        // setShowResults(false);
        showMessage('');
        console.log(`inside start ${isRunning}`);
        // let countdown = Math.ceil(config.preparationTime / 1000);
        // const countdownInterval = setInterval(() => {
        //     if (countdown > 0) {
        //         setDisplayText(countdown.toString());
        //         console.log(`Countdown: ${countdown}`);
        //         countdown--;
        //     } else {
        //         clearInterval(countdownInterval);
        //         displayWord();
        //     }
        // }, 1000);
        displayWord();
    };
        // const next = () => {
    //     console.log('Navigating to next page.');
    //     navigate('/IMGI2');
    // };

    /* ---------------------- End Game ---------------------- */
    const end = (badReaction) => {
        clearTimeout(delaywordRef.current);
        setWordsDisplayed(0);
        console.log('Game ended.');
        setIsRunning(false);
        // setShowNextButton(true);
        setIsTransitioning(false);
        if (wordTimeoutRef.current) {
            clearTimeout(wordTimeoutRef.current);
        }
        setDisplayText('');
        // setShowResults(true);

        console.log(badReaction);
        console.log(consecutiveGoodReactionsRef.current);
        if(badReaction){
            consecutiveGoodReactionsRef.current= 0;
        }else{
            if (consecutiveGoodReactionsRef.current >= 3) { // Check for 5 consecutive good reactions
                setIsKeyTrackingDisabled(true);
                console.log(isKeyTrackingDisabled);
                showMessage("");
                navigate('/IMGI2');
            }
        }
    };

    /* ---------------------- User Key Press Handling ---------------------- */
const handleSpacePress = (event) => {
        console.log('Space key pressed.');
        resetInactivityTimer(); // Reset inactivity timer on key press
        
        if (isKeyTrackingDisabled) {
            console.log('Key tracking is disabled. Ignoring key press.');
            return; // Ignore key presses if tracking is disabled
        }

        if (event.code === 'Space') {
            event.preventDefault(); // Prevent default space bar behavior
            
            if (isTransitioning) {
                console.log('Transitioning, ignoring space key.');
                return; // Do nothing during transition
            }

            if (!isRunning) {
                console.log('Starting the game.');
                start(); // Start the game if it's not running
            } else if (startTimeRef.current && isWordDisplaying) {
                setIsWordDisplaying(false);
                const reactionTime = performance.now() - startTimeRef.current;
                console.log(`Reaction time recorded: ${reactionTime}ms`);
                handleResponse(reactionTime);
            }
        }
    };

    /* ---------------------- Inactivity Timer ---------------------- */
    const resetInactivityTimer = () => {
        if (inactivityTimerRef.current) {
            clearTimeout(inactivityTimerRef.current);
        }
        setIsInactive(false); // Hide inactivity message
        inactivityTimerRef.current = setTimeout(() => {
            setIsInactive(true); // Show inactivity message after 2 minutes
        }, config.inactivityTime); // 4 minutes in milliseconds
    };

    /* ---------------------- Process User Reaction ---------------------- */
    const handleResponse = (reactionTime) => {
                console.log(`handleResponse called with reactionTime: ${reactionTime}`);
        if (wordTimeoutRef.current) clearTimeout(wordTimeoutRef.current);
        const isInvalidWord = config.invalidWords.includes(currentWordRef.current);

        if (isInvalidWord) {
            // Wrongly reacted to invalid number
            const errorResult = {
                Number: currentWordRef.current,
                reactionTime: 'Error: Wrong reaction '
            };
            setResults(prev => [...prev, errorResult]);
            let numberMessage = translation("IMG1_wrongNumberInstruction") + config.words;
            showMessage(numberMessage, true);
            end(true);
        } else if (reactionTime < config.minReactionTime) {
            showMessage(translation("IMG1_tooEarlyMessage"), true);
            end(true);
        } else if (reactionTime > config.maxReactionTime) {
            showMessage(translation("IMG1_tooSlowMessage"), true);
            end(true);
        } else {
            // Good reaction
                        const newResults = [...results, {
                Number: currentWordRef.current,
                reactionTime: reactionTime
            }];
            setResults(newResults);
            console.log(`New result added: ${JSON.stringify(newResults[newResults.length - 1])}`);

            //showMessage(`Good Match! Reaction time: ${reactionTime}ms`);
            setDisplayText('');
            setWordsDisplayed(prev => prev + 1);
            setIsTransitioning(true);// Start transition period
            // const randomDelay = config.delayBetweenWords + (Math.random() < 0.5 ? -config.delayedPlusMinus : config.delayedPlusMinus);
            // console.log(`random delay ${randomDelay}`);
            // //(Math.random()*(5000-300)+300)
            // setTimeout(() => {
            //     displayWord();
            // }, randomDelay);
            const randomDelay2 = Math.random() * (config.delayBetweenWordsMax - config.delayBetweenWordsMin) + config.delayBetweenWordsMin;
                        console.log(`random delay ${randomDelay2}`);
            delaywordRef.current = setTimeout(() => {
                if (isRunning) {
                    consecutiveGoodReactionsRef.current += 1;
                                        console.log(`consecutive - ${consecutiveGoodReactionsRef.current}`);
                    if (consecutiveGoodReactionsRef.current >= 3) {
                        end(false);
                    } else {
                        currentWordIndexRef.current += 1;
                        displayWord();
                    }
                }
            }, randomDelay2);
        }
    };

    /* ---------------------- Effect: Input and Inactivity Listeners ---------------------- */
    useEffect(() => {
        document.addEventListener('keydown', handleSpacePress);

        // Prevent page scroll when pressing space
        const preventScroll = (e) => {
            if (e.code === 'Space' && e.target === document.body) {
                e.preventDefault();
            }
        };
        window.addEventListener('keydown', preventScroll);

        resetInactivityTimer(); // Start countdown to inactivity

        // Reset inactivity on mouse movement
        const handleMouseMove = () => { resetInactivityTimer(); };
        window.addEventListener('mousemove', handleMouseMove);

        return () => {
            document.removeEventListener('keydown', handleSpacePress);
            window.removeEventListener('keydown', preventScroll);
            window.removeEventListener('mousemove', handleMouseMove);
            clearTimeout(inactivityTimerRef.current);
        };
    }, [isRunning, isWordDisplaying, isTransitioning]);

    /* ---------------------- UI Rendering ---------------------- */
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
            <div className="text-center p-6">

                {/* Top error message */}
                <div className="text-red-600 mb-8 text-left font-bold left-0 text-3xl">
                    {message1}
                </div>

                {/* Detailed instruction/error message */}
                {message && (
                    <ul className="list-disc mb-8 w-full ml-4 pl-2 text-left text-2xl font-medium">
                        <li>{message}</li>
                    </ul>
                )}

                {/* Second line reminder */}
                <div className="mb-7 text-left left-0 text-2xl font-medium">
                    {message2}
                </div>

                {/* Stimulus Display */}
                <div className="fixed inset-0 flex items-center justify-center text-6xl">
                    {displayText}
                </div>

                {/* Inactivity Overlay */}
                {isInactive && (
                    <div className="fixed inset-0 flex items-center justify-center bg-yellow-200">
                        <p className="text-5xl font-bold">{kioskTimeoutText.current}</p>
                    </div>
                )}
                                {/* Buttons */}
                {/* {showNextButton && (
                    <div className="flex justify-center space-x-4">
                        <button 
                            onClick={next} 
                            className="bg-black text-white px-4 py-2 rounded hover:bg-gray-800 transition duration-200"
                        >
                            Next
                        </button>
                    </div>
                )} */}

                {/* Results Area */}
                {/* {showResults && results.length > 0 && (
                    <div className="mt-6 bg-white p-6 rounded-lg shadow-md">
                        <h2 className="text-xl font-semibold mb-4">This screen is currently used for testing purpose, will be removed in the final version</h2>
                        <h2 className="text-xl font-semibold mb-4">Your Results:</h2>
                        <ul>
                            {results.map((result, index) => (
                                <li key={index}>
                                    Number: {result.Number}, Reaction Time: {result.reactionTime}ms
                                </li>
                            ))}
                        </ul>
                    </div>
                )} */}

            </div>
        </div>
    );
};

export default IMG1;